
import { combineReducers } from 'redux';
import CONSTANTS from '../constants';
import globalState from '../state';
import cursoInteresse from './curso-interesse';
import dadosInteressado from './dados-interessado';
import grupoFamiliar from './grupo-familiar';
import alteracao from './alteracao';
import { formataDataWebMethodParaString } from '../modules/util';
import fiadores from './fiadores';

let initialStateSol = globalState.solicitacao;

const globalError = (state = globalState.globalError, action) => {
    if (action.type === CONSTANTS.SET_ERROR) {

        var err = action.error ? action.payload && action.payload.message : "";
        if (err.indexOf("Informix") >= 0) {
            err = "Ocorreu um erro interno";
        }
        return err;
    } else if (action.type === CONSTANTS.NEXT_STEP) {
        return "";
    }
    return state;
};

const activeStep = (state = initialStateSol.activeStep, action) => {
    if (action.type === CONSTANTS.NEXT_STEP) {
        return state + 1;
    } else if (action.type === CONSTANTS.BACK_STEP) {
        return state - 1;
    }
    return state;
};

const valueAbaIndex = (state = globalState.valueAbaIndex, action) => {
    if (action.type === CONSTANTS.SET_ABA) {
        return action.payload.index;
    }
    return state
};
const aceite = (state = initialStateSol.aceite, action) => {
    if (action.type === CONSTANTS.SET_ACEITE) {
        return action.payload;
    }
    return state
};



const progressoFinalizar = (state = initialStateSol.progressoFinalizar, action) => {
    if (action.type === CONSTANTS.PROGRESS_FINALIZAR_CADASTRO) {
        return action.payload.msg;
    }
    if (action.type === CONSTANTS.FINALIZAR_CADASTRO.ERROR) {
        return "";
    }
    
    return state
};


const aceiteRegulamento = (state = initialStateSol.aceiteRegulamento, action) => {
    if (action.type === CONSTANTS.SET_ACEITE_REGULAMENTO) {
        return action.payload;
    }
    return state
};


const solSeq = (state = initialStateSol.solSeq, action) => {
    if (action.type === CONSTANTS.SET_SOL_SEQ) {
        return action.payload;
    }
    return state
};



const captcha = (state = initialStateSol.captcha, action) => {
    if (action.type === CONSTANTS.CHANGE_CAPTCHA) {
        return action.payload;
    }
    return state
};

const finalizando = (state = initialStateSol.finalizando, action) => {
    if (action.type === CONSTANTS.FINALIZAR_CADASTRO.LOADING) {
        return true;
    } else if (action.type === CONSTANTS.FINALIZAR_CADASTRO.SUCCESS || action.type === CONSTANTS.FINALIZAR_CADASTRO.ERROR) {
        return false;
    }
    return state
};

const msgSucesso = (state = initialStateSol.msgSucesso, action) => {
    // console.log(action, state);
    return state
};
const isAlteracao = (state = initialStateSol.isAlteracao, action) => {
    if (action.type === CONSTANTS.SET_IS_ALTERACAO) {
        return action.payload;
    }
    return state
};

const listNacionalidade = (state = globalState.listNacionalidade, action) => {
    if(action.type === CONSTANTS.CARREGAR_LIST_NACIONALIDADE.SUCCESS){
        return action.payload;
    }
    return state;
};

const listTpMoradia = (state = globalState.listTpMoradia, action) => {
    let payload = action.payload;
    if (action.type === CONSTANTS.CARREGAR_LIST_TPMORADIA.SUCCESS) {
        return payload;
    }
    return state 
};


const solicitacaoReducer = combineReducers({ captcha, alteracao, isAlteracao, msgSucesso, solSeq, finalizando, aceite, progressoFinalizar, aceiteRegulamento, activeStep, cursoInteresse, dadosInteressado, grupoFamiliar });


const _trim = (obj) => {
    if (obj) {
        for (var p in obj) {
            if (obj[p] && typeof obj[p] === "string" && obj[p].trim) {
                obj[p] = obj[p].trim();
            }
            if (obj[p] === null) {
                obj[p] = "";
            }
        }
    }
    return obj;
};

const solicitacao = (state = initialStateSol, action) => {
    var payload = action.payload;
    if (action.type === CONSTANTS.FINALIZAR_CADASTRO.SUCCESS) {
        return { ...initialStateSol, activeStep: state.activeStep + 1, msgSucesso: payload || "Solicitação realizada com sucesso" };
    } else if (action.type === CONSTANTS.GET_DADOS_ALTERACAO.SUCCESS) {
        /*
                 possuiCadastro = dtDados.Rows.Count > 0,
                dados = CWebUnoeste.UsoGeral.ConverteDataTableParaLista(dtDados),
                listFamilia = CW
        */

        var dados = payload.dados[0];
        var listFamilia = payload.listFamilia;

        var cursoInteresse = _trim({
            ...state.cursoInteresse,
            perSeq: dados.per_seq,
            perDtFim: dados.per_dtfim,
            erro: "",
            carregando: false,
            curCodigo: dados.cur_codigo,
            curURL: dados.cur_url,
            perPeriodo: dados.per_periodo,
            polCodigo: dados.pol_codigo,
            maximoPercent: dados.per_maxpercent,
            solPercentual: dados.sol_percentual,
            solMotivo: dados.sol_motivo
        });

        var dadosInteressado = _trim({
            ...state.dadosInteressado,
            uf: dados.loc_uf,
            carregandoCidades: false,
            nacCodigo: dados.nac_codigo,
            locCodigo: dados.loc_codigo,
            cpfOK: true,
            pesNro: dados.pes_nro,
            permissaoAlterar: payload.permissaoAlterar, //FALTA
            pesCPF: dados.pes_cpf,
            pesNome: dados.pes_nome,
            emlEmail: dados.email,
            pesDtNasc: formataDataWebMethodParaString(dados.pes_datnas),
            pesRG: dados.pes_rg,
            pesEstExp: dados.pes_estexp,
            pesOrgExp: dados.pes_orgexp,
            pesTelefone: dados.pes_telefone,
            pesCelular: dados.pes_celular,
            possuiAlgumaDeficiencia: dados.tdf_codigo ? "S" : "N",
            pesBairro: dados.pes_bairro,
            tdfCodigo: dados.tdf_codigo, //deficiencia                
            pesCEP: dados.pes_cep,
            pesRua: dados.pes_rua,
            pesEmpresa: dados.pes_empresa,
            pesDtAdmissao: formataDataWebMethodParaString(dados.pes_dtadmissao),
            pesCargo: dados.pes_cargo,
            pesRendaBruta: dados.pes_rendabruta,
            solAnoConcl2g: dados.sol_anoconcl2g,
            solRede2g: dados.sol_rede2g,
            solEnem: dados.sol_enem,
            solAnoEnem: dados.sol_anoenem,
            solPontEnem: dados.sol_pontenem,
            solCursoSup: dados.sol_cursosup,
            solNomeCursoSup: dados.sol_nomecursup,
            pesEstCiv: dados.pes_estciv,
            pesSexo: dados.pes_sexo,
            /**conjuge */
            conjugeNacCodigo: dados.nac_codigo_conjuge,
            conjugePermissaoAlterar: payload.conjugePermissaoAlterar,
            conjuge_carregandoPessoaCPF: false,
            conjuge_cpfOK: !!dados.cpf_conjuge,
            conjugePesCPF: dados.cpf_conjuge,
            conjugePesNro: dados.pes_nro_conjuge,
            conjugePesSexo: dados.pes_sexo_conjuge,
            conjugePesNome: dados.pes_nome_conjuge,
            conjugePesDtNasc: formataDataWebMethodParaString(dados.pes_datnas_conjuge),
            conjugePesRG: dados.pes_rg_conjuge,
            conjugePesTelefone: dados.pes_telefone_conjuge,
            conjugePesCelular: dados.pes_celular_conjuge,
            conjugePesEmpresa: dados.pes_empresa_conjuge,
            conjugePesCargo: dados.pes_cargo_conjuge,
            conjugePesRendaBruta: dados.pes_rendabruta_conjuge,
            conjugePesDtAdmissao: formataDataWebMethodParaString(dados.pes_dtadmissao_conjuge)
        });

        var grupoFamiliar = {
            ...state.grupoFamiliar,
            listArquivosGrupoFamiliar: payload.listArquivosGrupoFamiliar.map((item) => {
                return {...item, UplArquivo: item.UplBytes};
            }),
            solTpMoradia: dados.tip_seq,
            listFamiliar: listFamilia.map((item) => {
                return _trim({
                    famCpf: item.fam_Cpf,
                    famNome: item.fam_nome,
                    famIdade: item.fam_idade,
                    famParentesco: item.par_seq,
                    famEscolaridade: item.fam_escolaridade,
                    famProfissao: item.fam_profissao,
                    famRendaBruta: item.fam_rendabruta
                });
            }).filter((item) => {

                //não adiciona o conjuge e nao adiciona a propria pessoa (quando não tem parentesco)
                return item.famParentesco && item.famParentesco !== CONSTANTS.PARENTESCO_CODIGO_CONJUGE;
            })
        };

        return {
            ...state,
            alteracao: {
                carregando: false
            },
            isAlteracao: false,
            msgSucesso: "",
            solSeq: dados.sol_seq,
            aceite: false,
            finalizando: false,
            activeStep: 0,
            cursoInteresse: cursoInteresse,
            dadosInteressado: dadosInteressado,
            grupoFamiliar: grupoFamiliar
        };

    }



    return solicitacaoReducer(state, action);
};

const appReducer = combineReducers({
    valueAbaIndex,
    globalError,
    solicitacao: solicitacao,
    fiadores: fiadores,
    listTpMoradia: listTpMoradia,
    listNacionalidade: listNacionalidade
});

const rootReducer = (state, action) => {
    if (action.type === CONSTANTS.RESET) {
        state = undefined;
    }
    return appReducer(state, action);
}


export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js